import { jsx } from "react/jsx-runtime";
import { Heading } from "@zillow/zrs-cms";
import PropTypes from "prop-types";
import "react";
import { usePlacement } from "../../components/PlacementProvider/PlacementProvider.esm.js";
import makeContentInteractive from "../../util/makeSpansInteractive.esm.js";
const BlockHeading = ({
  attrs
}) => {
  const {
    content,
    textAlign = "inherit",
    level,
    margin,
    ...rest
  } = attrs;
  const interactiveContent = makeContentInteractive(content);
  const attributes = {
    as: "h2",
    fontType: {
      default: "h2"
    },
    fontFamily: "sansSerif",
    marginBottom: "sm",
    fontColor: "",
    textAlign,
    ...rest
  };
  if (level && !attrs.fontType) {
    attributes.fontType = `h${level}`;
  }
  if (typeof attributes.fontType === "string" && !attrs.as && /^h[1-6]$/.test(attributes.fontType)) {
    attributes.as = attributes.fontType;
  }
  return /* @__PURE__ */ jsx(Heading, { placement: usePlacement(), ...attributes, ...margin, children: interactiveContent });
};
BlockHeading.propTypes = {
  attrs: PropTypes.shape({
    as: PropTypes.oneOf(["h1", "h2", "h3", "h4", "h5", "h6"]),
    fontType: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    textStyle: PropTypes.string,
    content: PropTypes.string,
    textAlign: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    margin: PropTypes.object
  }),
  index: PropTypes.number
};
export {
  BlockHeading as default
};
